export const useLogout = async() => {
  const loading = ElLoading.service({
    lock: true,
  });

  if (useRoute().name?.includes('requests-id-chat') && useRoute().params.id && useAuthStore().user?.is_temp) {
    await useNuxtApp().$store.dispatch('client/requests/updateRequest', {
      id: useRoute().params.id,
      data: {
        state_id: 4,
      },
    }).catch((error) => console.error(error));
  }

  await useNuxtApp().$socket.sendObj({
    command: 'logout_everywhere',
  });

  await useAuthStore().logout();

  // Clear sessionStorage on logout
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.clear();
  }

  loading.close();

  await navigateTo(useLocalePath()('/login'));
  window.location.reload();
};
